var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33268 1.25C3.66602 1.66667 2.91686 2.91667 2.83268 5V8.33333H2.91686M11.166 8.33333H11.0818M6.99935 11.6667V13.3333M12.8327 12.5C12.8327 15.7217 10.221 18.3333 6.99935 18.3333C3.77769 18.3333 1.16602 15.7217 1.16602 12.5C1.16602 9.27834 3.77769 6.66667 6.99935 6.66667C10.221 6.66667 12.8327 9.27834 12.8327 12.5Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.9144c6f6d3101a757e3c6455d3586349.svg";
export { ForwardRef as ReactComponent };